"use client"

import { SkipForward } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SkipForwardIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SkipForwardIcon = component(Icon)({ as: SkipForward })
